import type { ParagraphEntity } from '@uncinc/react-drupal-core/types';
import type { ParagraphDownloads } from '../types/uncinc_profile/paragraphs';

const isAudioParagraph = (paragraph: ParagraphEntity) => {
  if (paragraph.type[0].target_id === 'downloads') {
    const downloads = (paragraph as ParagraphDownloads).field_downloads;
    return downloads.findIndex((d) => d.bundle !== 'audio') === -1;
  }

  return false;
};

export default isAudioParagraph;
